import { render, staticRenderFns } from "./createImg.vue?vue&type=template&id=3ff9236b&scoped=true&"
import script from "./createImg.vue?vue&type=script&lang=js&"
export * from "./createImg.vue?vue&type=script&lang=js&"
import style0 from "./createImg.vue?vue&type=style&index=0&id=3ff9236b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff9236b",
  null
  
)

export default component.exports